import type {
  ResourceAccessLevel,
  ResourceAccessScopeWithGrants
} from '@axilon-apps/domains-ontology-ui-state'

export const ACCESS_LEVEL_LABELS: Record<ResourceAccessLevel, string> = {
  viewer: 'Viewer',
  editor: 'Editor',
  co_owner: 'Co-owner'
}

/** Default levels a resource can be shared at. */
export const DEFAULT_ACCESS_LEVELS: readonly ResourceAccessLevel[] = [
  'viewer',
  'editor',
  'co_owner'
]

/**
 * Whether a user may change sharing: the owner or a direct co-owner. Group
 * co-owners are not known to the browser; the proxy stays authoritative.
 */
export function canManageScope(
  scope: ResourceAccessScopeWithGrants | undefined,
  userId: string | undefined
): boolean {
  if (!scope || !userId) return false
  if (scope.scope.ownerUserId === userId) return true
  return scope.userGrants.some((g) => g.userId === userId && g.accessLevel === 'co_owner')
}
